import { CompanyTitledPage } from "../../TitledPage";

import CustomerInfoEditTable from "../CustomerInfoEditTable";

import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { useNavigate } from "react-router-dom";

import { SYSTEM_PATH_COMPANY } from "../../../App";
import { CompanyPartHeader } from "../../../components/PartHeader";
import useInputObject from "../../../hooks/useInputObject";
import { insertCustomerInfo } from "../../../http/api/CustomerAPI";
import { useContext, useState } from "react";
import { ScreenStatusContext } from "../../../context/ScreenStatusContext";
import { MSG_CONFIRM_INPUT_CHANGE_NOT_UPDATED } from "../../../common/message";
import { confirmWhenChanged } from "../../../utils/validation";

const getCustomerLocationState = (customerId) => ({ customerId });

// 新規取引先登録ページ
export default function CustomerRegistrationPage() {
  const navigate = useNavigate();

  const customer = useInputObject({
    customerName: "",
    customerNameFurigana: "",
    address: "",
    tel: "",
    fax: "",
    email: "",
    buyerNo: "",
    orderFormColumnCountCd: 1,
    orderFormShopSummaryCd: 1,
    orderFormProductTypePartitionCd: 1,
    createdId: 1, //TODO JWTを追加した後削除する
    updatedId: 1, //TODO JWTを追加した後削除する
  });

  // 登録中をあらわすstate
  const [isRegistering, setRegistering] = useState(false);
  // 画面ステータスをcontextから取得
  const {isChanged} = useContext(ScreenStatusContext);

  // 戻るボタンをクリック
  const onClickReturn = (event) => {
    if (confirmWhenChanged(isChanged)) {
      navigate(-1);
    }
  };

  // 登録ボタンをクリック
  const onClickRegister = async (event) => {
    setRegistering(true);
    try {
      const newCustomerId = await insertCustomerInfo(customer.Value);
      alert("取引先を登録しました。");
      navigate(SYSTEM_PATH_COMPANY + "/customer_information", {
        state: getCustomerLocationState(newCustomerId),
      });
    } catch {
      alert("取引先を登録できなかった。");
    } finally {
      setRegistering(false);
    }
  };

  return (
    <CompanyTitledPage title="新規取引先登録">
      <CompanyPartHeader>
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>
              新規取引先情報の入力
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <Button variant="contained" onClick={onClickRegister} disabled={isRegistering}>
              登録
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button variant="outlined" onClick={onClickReturn}>
              戻る
            </Button>
          </Grid>
        </Grid>
      </CompanyPartHeader>

      <CustomerInfoEditTable customer={customer} />
    </CompanyTitledPage>
  );
}
